import PhotoGallery from '../../components/PhotoGallery/PhotoGallery.js';

function Home() {
    return (
        <>
            <div >
                <div className="master-table">
                    <div className="home-table">
                        <div className="home-row">
                            <PhotoGallery />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;